import { EnvironmentApplication } from './models/environment-application';
import { ContentType } from 'src/app/story/models/content-type.enum';
import { EnvironmentDeploy } from './models/environment-deploy';
import { EnvironmentPlatform } from './models/environment-platform';

export const environment = {
  production: true,
  assetDomain: 'assets-human.biodigital.com',
  supportEmail: 'support@biodigital.com',
  googleAuthKey: '66261904577-061oin26uo7sor0vrqc8dnn105irq82n.apps.googleusercontent.com',
  facebookAuthKey: '218801781466301',
  facebookPixelId: '973525219844030',
  googleAnalyticsId : 'UA-1141985-29',
  linkedinId: '2641938',
  pendoId: '3a783681-e53b-4ebd-69c0-788bbae48f13',
  rollbarToken: 'dd70f513aa0740668070fa3fd62b33a0',
  recaptchaKey: '6LdvZvcUAAAAAM0Z1St9WQXwvSYd__hMUY2WZ6um',
  application: EnvironmentApplication.Viewer,
  deploy: EnvironmentDeploy.Production,
  platform: EnvironmentPlatform.Web,
  exportType: ContentType.Bookmark,
  offline: false,
  native: false,
  minPasswordLength: 8
};
